import AuthTokenProvider from "@/presentation/adapters/AuthTokenProvider";
import HttpEventHandler from "@/presentation/adapters/HttpEventHandler";
import { NetworkService } from "@/services/NetworkService";

const httpEventHandler = new HttpEventHandler()
const authTokenProvider = new AuthTokenProvider()
const network = new NetworkService(httpEventHandler, authTokenProvider)

export default {
    httpEventHandler,
    authTokenProvider,
    network
}